import { Typography } from '@material-ui/core';
import React, { Component } from 'react';

export class ActivityIndexView extends Component {
  render() {
    return (
      <div>
        <Typography variant="h4" gutterBottom>
          ActivityIndex Page
        </Typography>
      </div>
    );
  }
}

export default ActivityIndexView;
